import { Injectable } from '@angular/core';
import { BaseComponent } from '@wms/app/components';
import { DialogService, WmHttpService } from '@wms/app/services';
import { environment } from "@wms/app";
import { PageWsService } from '@wms/app/workspace';

@Injectable({
  providedIn: 'root'
})
export class CopilotService extends BaseComponent {

  currentScreen: string = "copilot";

  private TARGET: string = 'COPILOT';
  private API_META: any = {
    generateContent: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/copilot/generate",
      method: "POST"
    }
  }

  constructor(private dialogService: DialogService, private wmHttpService: WmHttpService, private pageWsService: PageWsService) {
    super();
    wmHttpService.registerApiMeta(this.TARGET, this.API_META);
  }

  /**
   * Generates application resources (markup, scripts, styles, and variables) based on user prompt.
   */
  generateContent(prompt: any): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: "generateContent",
      pathParams: {
        projectID: this.projectService.getProjectId(),
        pageName: this.pageWsService.activePageName
      },
      data: prompt
    }) as Promise<any>);
  }

  /**
   * Set the active screen of the copilot
   * @param screen - The target screen to display
   */
  setActiveScreen(screen: string): void {
    this.currentScreen = screen;
    const isCopilotModalOpen: boolean = this.dialogService.openedDialogs.includes('copilot-modal');
    if (screen === 'prompt-screen' && !isCopilotModalOpen)
        this.dialogService.open('copilot-modal');
  }

}
